import { useContext } from 'react';
import type { WidgetBackgroundVariant } from '@onramp/components/AppThemeProvider';
import { WidgetBackgroundVariantContext } from '@onramp/components/AppThemeProvider';

export const useWidgetBackgroundVariant = (): WidgetBackgroundVariant => {
  return useContext(WidgetBackgroundVariantContext);
};
